import axios from 'axios';
import { AUTH_TOKEN } from "@/constants/auth"

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const authToken = localStorage.getItem(AUTH_TOKEN)

// TODO: временный костыль, проблема на бэке, а именно старый токен не сгорает
if (authToken) {
  localStorage.removeItem(AUTH_TOKEN)
  axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
} else if (document.head.querySelector('meta[name="XSRF-TOKEN"]')) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + document.head.querySelector('meta[name="XSRF-TOKEN"]').content
}

if (document.head.querySelector('meta[name="DD-TOKEN"]')) {
  axios.defaults.headers.common['X-DD-TOKEN'] = document.head.querySelector('meta[name="DD-TOKEN"]').content
}

if (document.head.querySelector('meta[name="MO-MODIFY"]')) {
  axios.defaults.headers.common['X-MO-MODIFY'] = document.head.querySelector('meta[name="MO-MODIFY"]').content
}

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

export default axios.create({
  baseURL: 'api endpoint',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
